export default __webpack_public_path__ + "static/media/hero-bg.2d5830d3.svg";